import * as React from 'react';
import Slide from '@mui/material/Slide';
import Dialog from '@mui/material/Dialog';
import { TransitionProps } from '@mui/material/transitions';
import { useHistory } from 'react-router-dom';
import PremiumMessage from './PremiumMessage';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="down" ref={ref} {...props} />;
});

const PremiumMessagePopup = ({ isOpened, togglePremium, isToggle = false }: any) => {

    const history = useHistory();
    return (
        <>
            <div>
                <Dialog
                    className="premiumMessage_modal"
                    sx={{ "& .MuiDialog-paper": { backgroundColor: "#faf6f5" } }}
                    fullScreen
                    disableEscapeKeyDown={true}
                    TransitionComponent={Transition}
                    open={isOpened}
                    onClose={history.goBack}
                >
                    <div className='premiumMessage-container' >
                        <PremiumMessage togglePremium={togglePremium} isToggle={isToggle} />
                    </div>
                </Dialog>
            </div>
        </>


    )
}


export default PremiumMessagePopup;